import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Card from "../generic/Card";

function SponsorsSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sponsorCards = [
    {
      id: "criteria_visibility",
      icon: "fas fa-eye",
      title: t("sponsors.criteria1.title"),
      description: t("sponsors.criteria1.description"),
    },
    {
      id: "criteria_partnership",
      icon: "fas fa-handshake",
      title: t("sponsors.criteria2.title"),
      description: t("sponsors.criteria2.description"),
    },
    {
      id: "criteria_impression",
      icon: "fas fa-leaf",
      title: t("sponsors.criteria3.title"),
      description: t("sponsors.criteria3.description"),
    },
    {
      id: "criteria_opportunities",
      icon: "fas fa-star",
      title: t("sponsors.criteria4.title"),
      description: t("sponsors.criteria4.description"),
    },
  ];

  const seeMore = () => {
    navigate("/sponsors");
    window.scrollTo(0, 0);
  };

  return (
    <section
      className="relative z-10 bg-slate-50/50 pt-12 pb-12 transition-colors dark:bg-slate-900"
      id="sponsors-section"
      aria-labelledby="sponsors-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="sponsors-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("sponsors.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-pretty text-lg leading-relaxed text-slate-600 dark:text-slate-400">
            {t("sponsors.description")}
          </p>
        </header>

        <ul className="m-0 mb-10 grid list-none grid-cols-1 gap-5 p-0 sm:grid-cols-2 md:gap-6 xl:grid-cols-4">
          {sponsorCards.map((item) => (
            <li key={item.id} className="min-h-0">
              <Card
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            </li>
          ))}
        </ul>

        <div className="flex justify-center">
          <button
            type="button"
            onClick={seeMore}
            className="inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 dark:bg-primary-light dark:hover:bg-primary dark:focus-visible:ring-primary-light/40 dark:focus-visible:ring-offset-slate-900 md:px-6 md:py-3"
          >
            <span>{t("button.see_more")}</span>
            <i className="fas fa-arrow-right text-xs opacity-90" aria-hidden />
          </button>
        </div>
      </div>
    </section>
  );
}

export default SponsorsSection;
